module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar', {
    attrs: {
      "title": "陈妍希"
    }
  }), _vm._v(" "), _c('scroller', {
    ref: "my_scroller",
    staticClass: "my-scroller",
    staticStyle: {
      "top": "44px"
    },
    attrs: {
      "on-refresh": _vm.refresh
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "row",
      class: {
        'grey-bg': index % 2 == 0
      }
    }, [_vm._v("\n      " + _vm._s(item) + "\n    ")])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fe17ee4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/Custom.vue
// module id = 48
// module chunks = 0